import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import SeccionTitle from "../../atoms/seccion-title/seccionTitle";
import InfoModal from "../../molecules/info-modal/infoModal";
import "./sectionConfirmation.scss";
import { AddToCalendarButton } from "add-to-calendar-button-react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

interface SectionConfirmationInterface {
  setnextPage: any;
  content: any;
  confirmationDate: any;
  reprogramming?: any;
  resp: any;
}

const SectionConfirmation = (props: SectionConfirmationInterface) => {
  const { setnextPage, content, confirmationDate, reprogramming, resp } = props;

  const data = useStaticQuery(graphql`
    query INFO_CONTENT {
      allContentfulPlantillaContenido(
        filter: {
          titulo: { eq: "red amor > información solicitud retorno activo" }
        }
      ) {
        nodes {
          id
          titulo
          tituloBanner
          tituloBoton
          tituloDescripcion
          descripcion {
            raw
          }
        }
      }
    }
  `)?.allContentfulPlantillaContenido.nodes[0];
  const [event, setEvent] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const items = [
    { outlook: "Outlook" },
    { outlookcom: "Outlook.com" },
    { apple: "Apple Calendar" },
    { yahoo: "Yahoo" },
    { google: "Google" },
  ];
  const [urlDirection, setUrlDirection] = useState("");
  const [productInfo, setProductInfo] = useState({});
  const [reprogrammingText, setReprogrammingText] = useState(
    "REALIZAR EL PAGO"
  );
  const reprogrammingF = () => {
    if (reprogramming || resp?.data?.data?.isSubscriptionFree) {
      setReprogrammingText("FINALIZAR");
    } else {
      setReprogrammingText("REALIZAR EL PAGO");
    }
  };
  const handleCreateEvents = () => {
    let event = {
      title: `Cita con ${confirmationDate.service.name}`,
      description: `Profesional ${confirmationDate.resource.name}`,
      location: "Medellin, CO",
      startTime: `${confirmationDate.dateTime.split(" ")[0]}T${formatHour(
        confirmationDate.dateTime.split(" ")[1]
      )}:00-05:00`,
      endTime: `${confirmationDate.dateTime.split(" ")[0]}T${timeToEnd(
        formatHour(confirmationDate.dateTime.split(" ")[1])
      )}:00-05:00`,
    };

    setEvent(event);
  };

  const consumResp = () => {
    let updatedUrlDirection = "";

    if (reprogramming) {
      updatedUrlDirection = `${window.location.origin}/red-de-amor/`;
    } else {
      if (resp) {
        if (resp.data.data.isSubscriptionFree) {
          updatedUrlDirection = `${window.location.origin}/red-de-amor/servicios-activos`;
        } else {
          updatedUrlDirection = `${resp.data.data.serviceApp.serviceUrlRedirect}?origin_url=${process.env.SITE_URL}/red-de-amor/resultados-transaccion/`;
          setProductInfo({
            productCode: resp.data.data.serviceApp.serviceCommerceCode,
            productName: resp.data.data.serviceApp.serviceName,
            productUrl: updatedUrlDirection,
          });
        }
      }
    }
    setUrlDirection(updatedUrlDirection);
  };

  useEffect(() => {
    consumResp();
    setnextPage("");
    handleCreateEvents();
    reprogrammingF();
  }, []);

  const formatHour = (time) => {
    let hour = time.split(":")[0];
    if (hour.lenght < 2) {
      let hourFormated = 0 + time;
      return hourFormated;
    } else {
      return time;
    }
  };

  const timeToEnd = (time) => {
    let minutes = time.split(":")[1];
    let hour = time.split(":")[0];

    if (minutes == "00") {
      minutes = "30";
      return hour + ":" + minutes;
    } else {
      if (hour.split("")[0] == "0") {
        let h = parseFloat(hour) + 1;
        minutes = "00";
        return "0" + h + ":" + minutes;
      } else {
        let h = parseFloat(hour) + 1;
        minutes = "00";
        return h + ":" + minutes;
      }
    }
  };
  const locationsRepro = () => {
    if (reprogramming) {
      window.location.assign(
        `${window.location.origin}/red-de-amor/servicios-activos#reprogramar`
      );
    } else {
      localStorage.setItem("productInfo", JSON.stringify(productInfo));
      window.location.assign(`${urlDirection}`);
    }
  };

  return (
    <>
      <InfoModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        continuarCompra={locationsRepro}
        data={data}
      />
      <div className="o-confirmation">
        <div className="o-confirmation__left">
          <SeccionTitle title={"Confirmación cita"} />
          <div className="o-confirmation__right__success">
            <p className="o-confirmation__right__success__text">
              ¡Tu cita ha sido agendada con éxito!
            </p>
          </div>
          <div className="o-confirmation__right__add--calendar">
            <p className="o-confirmation__right__add--calendar__text">
              ¿Deseas agregarla a tu calendario?
            </p>
            <AddToCalendarButton
              startDate={event}
              label="AGREGAR"
              // options={items}
            />
          </div>
        </div>
        <div className="o-confirmation__right">
          <div className="o-confirmation__right__indications">
            <p className="o-confirmation__right__indications__title">
              {content.tituloBanner}
            </p>
            <div className="o-confirmation__right__indications__content">
              {documentToReactComponents(JSON.parse(content?.descripcion?.raw))}
            </div>
          </div>
          <div className="o-confirmation__right__btn">
            <div
              className="o-confirmation__right__btn_finally"
              onClick={() => {
                setIsOpen(true);
              }}
            >
              {reprogrammingText}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SectionConfirmation;
